webpackJsonp([42],{

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(21);






function Resource(base, otherActions) {
  this.base = base;
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this, otherActions);
}

Resource.prototype = {
  get: function get(id, options) {
    var url = '/' + this.base;
    if ((typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(id)) === 'object') {
      options = id;
    } else if (id !== undefined) {
      url += '/' + id;
    }
    return __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* axios */].get(url, options);
  },
  delete: function _delete(id, options) {
    var url = '/' + this.base + '/' + id;
    return __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* axios */].delete(url, options);
  },
  post: function post(id, options) {
    var url = '/' + this.base;
    if ((typeof id === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(id)) === 'object') {
      options = id;
    } else if (id !== undefined) {
      url += '/' + id;
    }
    return __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* axios */].post(url, options);
  },
  put: function put(id, options) {
    var url = '/' + this.base + '/' + id;
    return __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* axios */].put(url, options);
  },
  patch: function patch(id, options) {
    var url = '/' + this.base + '/' + id;
    return __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* axios */].patch(url, options);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Resource);

/***/ }),

/***/ 107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_zh_CN__);






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var messages = {
  zh: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    message: __webpack_require__(309)
  }, __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_zh_CN___default.a)
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: 'zh',
  messages: messages
}));

/***/ }),

/***/ 108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nprogress__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authorize__ = __webpack_require__(171);








/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__axios__["a" /* default */])(Vue);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* default */])(Vue);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nprogress__["a" /* default */])(Vue);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__authorize__["a" /* default */])(Vue);
  }
});

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(288)

var Component = __webpack_require__(114)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto_js__);


var KEY = 'dashoo123456abcd';
var IV = 'dashoo123456abcd';

/* harmony default export */ __webpack_exports__["a"] = ({
  encrypt: function encrypt(word) {
    var key = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.parse(KEY);
    var iv = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.parse(IV);
    var srcs = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.parse(word);
    var encrypted = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.AES.encrypt(srcs, key, {
      iv: iv,
      mode: __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.mode.CBC,
      padding: __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.pad.Pkcs7
    });
    return encrypted.toString();
  },
  decrypt: function decrypt(word) {
    var key = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.parse(KEY);
    var iv = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.parse(IV);

    var decrypt = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.AES.decrypt(word, key, {
      iv: iv,
      mode: __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.mode.CBC,
      padding: __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.pad.Pkcs7
    });
    return __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.stringify(decrypt).toString();
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(42);





/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].beforeHooks.unshift(function (to, from, next) {
    if (!to.meta.requiresAuth) return next();

    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('checkToken').then(function (valid) {
      if (valid) return next();

      console.log('Unauthorized');
      next({ name: 'login', query: { redirect: to.fullPath } });
    });
  });
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue, {
    axios: { get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* axios */];
      } }
  });

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
    $axios: { get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* axios */];
      } }
  });
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(21);







/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* nprogress */].start();
    next();
  });
  __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (route) {
    __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* nprogress */].done();
  });

  __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* axios */].interceptors.request.use(function (config) {
    __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* nprogress */].start();
    return config;
  });
  __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* axios */].interceptors.response.use(function (response) {
    __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* nprogress */].done();
    return response;
  }, function (err) {
    __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* nprogress */].done();
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
    $nprogress: { get: function get() {
        return __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* nprogress */];
      } }
  });
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(84);



/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  var services = {
    comment: __WEBPACK_IMPORTED_MODULE_1__services__["c" /* CommentService */],
    option: __WEBPACK_IMPORTED_MODULE_1__services__["d" /* OptionService */],
    post: __WEBPACK_IMPORTED_MODULE_1__services__["e" /* PostService */],
    term: __WEBPACK_IMPORTED_MODULE_1__services__["f" /* TermService */],
    token: __WEBPACK_IMPORTED_MODULE_1__services__["a" /* TokenService */],
    user: __WEBPACK_IMPORTED_MODULE_1__services__["b" /* UserService */],
    channel: __WEBPACK_IMPORTED_MODULE_1__services__["g" /* ChannelService */],
    alert: __WEBPACK_IMPORTED_MODULE_1__services__["h" /* AlertService */],
    action: __WEBPACK_IMPORTED_MODULE_1__services__["i" /* ActionService */],
    triggerinfo: __WEBPACK_IMPORTED_MODULE_1__services__["j" /* TriggerinfoService */],
    trigger: __WEBPACK_IMPORTED_MODULE_1__services__["k" /* TriggerService */],
    report: __WEBPACK_IMPORTED_MODULE_1__services__["l" /* ReportService */],
    monthreport: __WEBPACK_IMPORTED_MODULE_1__services__["m" /* MonthReportService */],
    dataexport: __WEBPACK_IMPORTED_MODULE_1__services__["n" /* DataExportService */],
    loginfo: __WEBPACK_IMPORTED_MODULE_1__services__["o" /* LoginfoService */],
    authcodeman: __WEBPACK_IMPORTED_MODULE_1__services__["p" /* AuthcodemanService */],
    abnormal: __WEBPACK_IMPORTED_MODULE_1__services__["q" /* AbnormalService */],
    organizes: __WEBPACK_IMPORTED_MODULE_1__services__["r" /* OrganizeService */],
    permissions: __WEBPACK_IMPORTED_MODULE_1__services__["s" /* PermissionsService */],
    orgpermissions: __WEBPACK_IMPORTED_MODULE_1__services__["t" /* OrgpermissionService */],
    device: __WEBPACK_IMPORTED_MODULE_1__services__["u" /* DeviceService */],
    equipment: __WEBPACK_IMPORTED_MODULE_1__services__["v" /* EquipmentService */],
    expirechannels: __WEBPACK_IMPORTED_MODULE_1__services__["w" /* Expirechannels */]
  };

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue, {
    services: { get: function get() {
        return services;
      } }
  });

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
    $services: { get: function get() {
        return services;
      } }
  });
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'demo',
  path: 'demo',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
      return resolve(__webpack_require__(321));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'demo-data',
  path: 'demo/data',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
      return resolve(__webpack_require__(319));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'demo-vuex',
  path: 'demo/vuex',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
      return resolve(__webpack_require__(323));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'demo-i18n',
  path: 'demo/i18n',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
      return resolve(__webpack_require__(320));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'demo-cors',
  path: 'demo/cors',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
      return resolve(__webpack_require__(318));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'demo-params',
  path: 'demo/:name',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
      return resolve(__webpack_require__(322));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'components',
  path: 'components',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
      return resolve(__webpack_require__(316));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'components-icons',
  path: 'components/icons',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
      return resolve(__webpack_require__(315));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'components-button',
  path: 'components/button',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
      return resolve(__webpack_require__(314));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'components-table',
  path: 'components/table',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
      return resolve(__webpack_require__(317));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__demo_routes__ = __webpack_require__(175);


/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'dashboard',
  path: '',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(9).then((function () {
      return resolve(__webpack_require__(343));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'update',
  path: 'update',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(35).then((function () {
      return resolve(__webpack_require__(360));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'about',
  path: 'about',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(40).then((function () {
      return resolve(__webpack_require__(329));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'profile',
  path: 'profile',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
      return resolve(__webpack_require__(353));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'management',
  path: 'management',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
      return resolve(__webpack_require__(346));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'equipment',
  path: 'equipment',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
      return resolve(__webpack_require__(339));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'deviceschart',
  path: 'devices/chart/:serial',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(10).then((function () {
      return resolve(__webpack_require__(336));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'channelschart',
  path: 'channels/chart/:serial',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(11).then((function () {
      return resolve(__webpack_require__(333));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'devicesgps',
  path: 'devices/gps/:serial',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(17).then((function () {
      return resolve(__webpack_require__(337));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'sgmanage',
  path: 'sgmanage',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(21).then((function () {
      return resolve(__webpack_require__(358));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'new',
  path: 'new/:type',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
      return resolve(__webpack_require__(348));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'edit',
  path: 'edit/:type/:slug?',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
      return resolve(__webpack_require__(338));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'alerts',
  path: 'alerts',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(14).then((function () {
      return resolve(__webpack_require__(331));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'upload',
  path: 'upload',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(34).then((function () {
      return resolve(__webpack_require__(361));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'users',
  path: 'users/:page?',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
      return resolve(__webpack_require__(363));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'roles',
  path: 'roles',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
      return resolve(__webpack_require__(357));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'permissions',
  path: 'permissions',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
      return resolve(__webpack_require__(352));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'reports',
  path: 'reports',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(22).then((function () {
      return resolve(__webpack_require__(356));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'monthreports',
  path: 'monthreports',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(26).then((function () {
      return resolve(__webpack_require__(347));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'dataexports',
  path: 'dataexports',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(29).then((function () {
      return resolve(__webpack_require__(335));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'chartreport',
  path: 'chartreport',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(12).then((function () {
      return resolve(__webpack_require__(334));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'organreport',
  path: 'organreport',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(24).then((function () {
      return resolve(__webpack_require__(351));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'install',
  path: 'install/:type',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(37).then((function () {
      return resolve(__webpack_require__(344));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'import',
  path: 'import',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(38).then((function () {
      return resolve(__webpack_require__(342));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'options',
  path: 'options/:type',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(36).then((function () {
      return resolve(__webpack_require__(349));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'actions',
  path: 'actions',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(31).then((function () {
      return resolve(__webpack_require__(330));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'triggerinfos',
  path: 'triggerinfos',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(20).then((function () {
      return resolve(__webpack_require__(359));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'usersetting',
  path: 'usersetting',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(16).then((function () {
      return resolve(__webpack_require__(364));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'organize',
  path: 'organize',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(25).then((function () {
      return resolve(__webpack_require__(350));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'userchangepwd',
  path: 'userchangepwd',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(19).then((function () {
      return resolve(__webpack_require__(362));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'expirechannels',
  path: 'expirechannels',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(28).then((function () {
      return resolve(__webpack_require__(340));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'loginfo',
  path: 'loginfo',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(27).then((function () {
      return resolve(__webpack_require__(345));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'authcodeman',
  path: 'authcodeman',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(30).then((function () {
      return resolve(__webpack_require__(332));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'abnormalsetting',
  path: 'abnormalsetting',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(15).then((function () {
      return resolve(__webpack_require__(328));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'abnormalmsg',
  path: 'abnormalmsg',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(32).then((function () {
      return resolve(__webpack_require__(327));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'icons',
  path: 'icons',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(39).then((function () {
      return resolve(__webpack_require__(341));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'record_history',
  path: 'record_history',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(23).then((function () {
      return resolve(__webpack_require__(354));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'record_history_lock',
  path: 'record_history_lock',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(18).then((function () {
      return resolve(__webpack_require__(355));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}].concat(__WEBPACK_IMPORTED_MODULE_0__demo_routes__["a" /* default */]));

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_routes__ = __webpack_require__(176);


/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'login',
  path: '/login',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(8).then((function () {
      return resolve(__webpack_require__(326));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'regedit',
  path: '/regedit/:source',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(13).then((function () {
      return resolve(__webpack_require__(365));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'home',
  path: '/home',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(7).then((function () {
      return resolve(__webpack_require__(324));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  path: '/',
  meta: { requiresAuth: true },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
      return resolve(__webpack_require__(325));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  },
  children: __WEBPACK_IMPORTED_MODULE_0__main_routes__["a" /* default */]
}, {
  name: 'not-found',
  path: '*',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
      return resolve(__webpack_require__(124));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}, {
  name: 'not404',
  path: '/404',
  meta: { requiresAuth: false },
  component: function component(resolve) {
    return __webpack_require__.e/* require.ensure */(33).then((function () {
      return resolve(__webpack_require__(124));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('abnormals'));

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('actions'));

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('alerts'));

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('authcodemans'));

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('channels'));

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('comments'));

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('dataexports'));

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('device'));

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('equipment'));

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('expirechannels'));

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('loginfos'));

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('monthreports'));

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('options'));

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('organizes'));

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('orgpermissions'));

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('permissions'));

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('posts'));

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('reports'));

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('terms'));

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('tokens'));

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('triggerinfos'));

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('triggers'));

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resource__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__resource__["a" /* default */]('users'));

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeTitle", function() { return changeTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createToken", function() { return createToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkToken", function() { return checkToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteToken", function() { return deleteToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUser", function() { return getCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebarCollapse", function() { return toggleSidebarCollapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "increment", function() { return increment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "incrementAsync", function() { return incrementAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrement", function() { return decrement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrementAsync", function() { return decrementAsync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(84);



var changeTitle = function changeTitle(_ref, title) {
  var commit = _ref.commit;

  commit('CHANGE_SESSION', { title: title });
};

var createToken = function createToken(_ref2, _ref3) {
  var commit = _ref2.commit;
  var username = _ref3.username,
      password = _ref3.password;

  return __WEBPACK_IMPORTED_MODULE_1__services__["a" /* TokenService */].post({
    username: username.trim(),
    password: password.trim()
  }).then(function (res) {
    commit('CHANGE_SESSION', { token: res.data.token });
    return res.data.token;
  });
};

var checkToken = function checkToken(_ref4) {
  var commit = _ref4.commit,
      getters = _ref4.getters;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!getters.session.token) {
      return resolve(false);
    }

    __WEBPACK_IMPORTED_MODULE_1__services__["a" /* TokenService */].get().then(function (res) {
      return resolve(true);
    }).catch(function (err) {
      console.error(err);
      commit('CHANGE_SESSION', { token: null });
      resolve(false);
    });
  });
};

var deleteToken = function deleteToken(_ref5) {
  var commit = _ref5.commit;

  commit('CHANGE_SESSION', { token: null });
};

var getCurrentUser = function getCurrentUser(_ref6) {
  var commit = _ref6.commit;

  return __WEBPACK_IMPORTED_MODULE_1__services__["b" /* UserService */].get('me').then(function (res) {
    commit('CHANGE_SESSION', { user: res.data });
    return res.data;
  });
};

var toggleSidebarCollapse = function toggleSidebarCollapse(_ref7) {
  var commit = _ref7.commit;

  commit('TOGGLE_SIDEBAR_COLLAPSE');
};

var increment = function increment(_ref8) {
  var commit = _ref8.commit;
  return commit('INCREMENT');
};

var incrementAsync = function incrementAsync(_ref9) {
  var commit = _ref9.commit;
  return setTimeout(function () {
    return commit('INCREMENT');
  }, 1000);
};

var decrement = function decrement(_ref10) {
  var commit = _ref10.commit;
  return commit('DECREMENT');
};

var decrementAsync = function decrementAsync(_ref11) {
  var commit = _ref11.commit;
  return setTimeout(function () {
    return commit('DECREMENT');
  }, 1000);
};

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "title", function() { return title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "session", function() { return session; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "header", function() { return header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "count", function() { return count; });

var title = function title(state) {
  return state.title;
};

var session = function session(state) {
  return state.session;
};

var header = function header(state) {
  return state.header;
};

var sidebar = function sidebar(state) {
  return state.sidebar;
};

var count = function count(state) {
  return state.count;
};

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);


var state = {
  message: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* storage */].get('dashoo_demo_message')
};

var getters = {
  message: function message(state) {
    return state.message;
  }
};

var mutations = {
  CHANGE_MESSAGE: function CHANGE_MESSAGE(state, message) {
    state.message = message;
  }
};

var actions = {
  changeMessage: function changeMessage(_ref, message) {
    var commit = _ref.commit;

    console.log(message);
    commit('CHANGE_MESSAGE', message);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, mutations: mutations, actions: actions });

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var _this = this;

var state = {
  equipmentModel: {
    brands: '',
    dModel: '',
    code: '',
    organizeName: '',
    organizeId: 0,
    devicestate: '1',
    title: '',
    serial: '',
    about: '',
    modelid: 0
  },
  deviceModel: {
    title: '',
    serial: '',
    tagCode: '',
    about: '',
    devicestate: '1',
    equipmentId: 0,
    equipmentCode: ''
  },
  triggerModel: {
    column: 'temperature',
    item: '1',
    value: '',
    aid: [],
    etype: '1',
    count: '2',
    rangeweek: ['1', '2', '3', '4', '5', '6', '7'],
    rangetime: [0, 48],
    enabled: '1',
    content: '您的设备{c}，在{t}时 温度 为{v}出现异常',
    dataitem: '',
    serial: '',
    title: '',
    disabletriggeritem: false,
    disabletriggervalue: false,
    operatingitem: 0,
    id: 0
  },
  triggerDeviceModel: {
    serial: '',
    title: '',
    dataitem: ''
  }
};

var getters = {
  deviceModel: function deviceModel(state) {
    return state.deviceModel;
  },
  triggerModel: function triggerModel(state) {
    return state.triggerModel;
  },
  triggerDeviceModel: function triggerDeviceModel(state) {
    return state.triggerDeviceModel;
  },
  equipmentModel: function equipmentModel(state) {
    return state.equipmentModel;
  }
};

var mutations = {
  Device_New_Model2: function Device_New_Model2(state) {
    state.equipmentModel = {
      brands: '',
      dModel: '',
      code: '',
      organizeName: '',
      organizeId: 0,
      devicestate: '1',
      title: '',
      serial: '',
      about: ''
    };
  },
  Device_New_Model: function Device_New_Model(state, value) {
    state.deviceModel = {
      title: '',
      serial: '',
      tagCode: '',
      about: '',
      devicestate: '1',
      equipmentId: 0,
      equipmentCode: value.title
    };
    if (value.title !== 'new') {
      state.deviceModel.title = value.title + '-';
    }
    state.deviceModel.equipmentId = value.equipid;
  },
  Device_Edit_Model: function Device_Edit_Model(state, value) {
    state.deviceModel.MaxValue = value.MaxValue;
    state.deviceModel.MinValue = value.MinValue;
    state.deviceModel.title = value.title;
    state.deviceModel.serial = value.Serial;
    state.deviceModel.equipmentCode = value.equipmentCode;
  },
  Trigger_New_Model: function Trigger_New_Model(state, value) {
    state.triggerModel = {
      column: 'temperature',
      item: '1',
      value: '',
      aid: [],
      etype: '1',
      count: '2',
      rangeweek: ['1', '2', '3', '4', '5', '6', '7'],
      rangetime: [0, 48],
      enabled: '1',
      content: '您的设备{c}，在{t}时 温度 为{v}出现异常',
      dataitem: '',
      serial: '',
      title: '',
      disabletriggeritem: false,
      disabletriggervalue: false,
      operatingitem: 0,
      id: 0
    };
    state.triggerModel.operatingitem = value.index;
    state.triggerModel.id = value.cindex;

    state.triggerModel.column = value.column;
    state.triggerModel.serial = state.triggerDeviceModel.serial;
    state.triggerModel.dataitem = state.triggerDeviceModel.dataitem;
    state.triggerModel.title = state.triggerDeviceModel.title;
  },
  Trigger_Edit_Model: function Trigger_Edit_Model(state, value) {
    state.triggerModel.column = value.Trigger.column;
    state.triggerModel.item = value.Trigger.item + '';
    state.triggerModel.value = value.Trigger.value + '';
    state.triggerModel.aid = value.Trigger.aid.split(',');
    state.triggerModel.etype = value.Trigger.etype + '';
    state.triggerModel.count = value.Trigger.count + '';
    state.triggerModel.rangeweek = value.Trigger.rangeweek.split('');
    state.triggerModel.rangetime = [value.Trigger.rangestartint, value.Trigger.rangeendint];
    state.triggerModel.enabled = value.Trigger.enabled + '';
    state.triggerModel.content = value.Trigger.content;
    state.triggerModel.id = value.Trigger.id;

    state.triggerModel.serial = state.triggerDeviceModel.serial;
    state.triggerModel.dataitem = state.triggerDeviceModel.dataitem;
    state.triggerModel.title = state.triggerDeviceModel.title;
  },
  Trigger_Set_Device_Model: function Trigger_Set_Device_Model(state, value) {
    state.triggerDeviceModel.serial = value.serial;
    state.triggerDeviceModel.dataitem = value.dataitem;
    state.triggerDeviceModel.title = value.title;
  }
};

var actions = {
  deviceNewModel2: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, value) {
      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit('Device_New_Model2');

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function deviceNewModel2(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(),
  deviceNewModel: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, value) {
      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit('Device_New_Model', value);

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function deviceNewModel(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }(),
  deviceEditModel: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, value) {
      var commit = _ref6.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit('Device_Edit_Model', value);

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function deviceEditModel(_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }(),
  triggerNewModel: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8, value) {
      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit('Trigger_New_Model', value);

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function triggerNewModel(_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }(),
  triggerEditModel: function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref10, value) {
      var commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit('Trigger_Edit_Model', value);

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function triggerEditModel(_x9, _x10) {
      return _ref9.apply(this, arguments);
    };
  }(),
  triggerSetDeviceModel: function () {
    var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref12, value) {
      var commit = _ref12.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit('Trigger_Set_Device_Model', value);

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function triggerSetDeviceModel(_x11, _x12) {
      return _ref11.apply(this, arguments);
    };
  }()
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__options__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__devices__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demo__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "devices", function() { return __WEBPACK_IMPORTED_MODULE_2__devices__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return __WEBPACK_IMPORTED_MODULE_0__options__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "users", function() { return __WEBPACK_IMPORTED_MODULE_1__users__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "demo", function() { return __WEBPACK_IMPORTED_MODULE_3__demo__["a"]; });







/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);




var _this = this;

var state = {
  options: {}
};

var getters = {
  options: function options(state) {
    return state.options;
  }
};

var mutations = {
  CHANGE_OPTIONS: function CHANGE_OPTIONS(state, options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(state.options, options);
  }
};

var actions = {
  changeOptions: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, options) {
      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit('CHANGE_OPTIONS', {});

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function changeOptions(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }()
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, mutations: mutations, actions: actions });

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {};

var getters = {};

var mutations = {};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, getters: getters, mutations: mutations, actions: actions });

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_SESSION", function() { return CHANGE_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_SIDEBAR_COLLAPSE", function() { return TOGGLE_SIDEBAR_COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INCREMENT", function() { return INCREMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DECREMENT", function() { return DECREMENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(21);



var CHANGE_SESSION = function CHANGE_SESSION(state, session) {
  if (session && session.token) {
    __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* axios */].defaults.headers.Authorization = 'Bearer ' + session.token;
  }

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.session, session);
  __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* storage */].set('dashoo_session_info', state.session);
};

var TOGGLE_SIDEBAR_COLLAPSE = function TOGGLE_SIDEBAR_COLLAPSE(state) {
  state.sidebar.collapse = !state.sidebar.collapse;
  __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* storage */].set('dashoo_sidebar_collapse', state.sidebar.collapse);
};

var INCREMENT = function INCREMENT(state) {
  state.count++;
  __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* storage */].set('dashoo_demo_count', state.count);
};

var DECREMENT = function DECREMENT(state) {
  state.count--;
  __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* storage */].set('dashoo_demo_count', state.count);
};

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(21);


var state = {
  session: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* storage */].get('dashoo_session_info') || {},

  header: {
    name: 'LabSOP',

    menus: [{
      text: '平台首页',
      icon: 'home',
      name: 'dashboard'
    }, {
      text: '设备日报',
      icon: 'stats-bars',
      name: 'reports'
    }, {
      text: '提醒设置',
      icon: 'alarm',
      name: 'abnormalsetting'
    }, {
      text: '账户设置',
      icon: 'credit-card',
      name: 'usersetting'
    }]
  },

  sidebar: {
    copyright: 'MCS-01',

    collapse: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* storage */].get('dashoo_sidebar_collapse'),

    menus: [{
      title: ''
    }, {
      text: '平台首页',
      icon: 'home3',
      name: 'dashboard'
    }, {
      text: '设备管理',
      icon: 'laptop',
      name: 'equipment'
    }, {
      text: '网关管理',
      icon: 'drive',
      name: 'sgmanage',
      params: { type: 'sgmanage' }
    }, {
      text: '报警管理',
      icon: 'bell',
      name: 'actions',
      children: [{ text: '报警项目', name: 'actions' }, { text: '报警器管理', name: 'alerts' }, { text: '报警历史', name: 'triggerinfos' }]
    }, {
      text: '报表输出',
      icon: 'table',
      name: 'reports',
      children: [{ text: '设备日报', name: 'reports' }, { text: '周报月报', name: 'monthreports', params: { type: 'plugin' } }, { text: '数据输出', name: 'dataexports', params: { type: 'plugin' } }, { text: '曲线报表', name: 'chartreport' }, { text: '科室报表', name: 'organreport' }, { text: '开锁报表', name: 'record_history_lock' }]
    }, {
      text: '用户管理',
      icon: 'users',
      name: 'users'
    }, {
      text: '账户管理',
      icon: 'credit-card',
      name: 'usersetting',
      children: [{ text: '账户设置', name: 'usersetting' }, { text: '组织管理', name: 'organize' }, { text: '过期模块', name: 'expirechannels' }, { text: '账户一览', name: 'management' }, { text: '密码修改', name: 'userchangepwd' }]
    }, {
      text: '日志管理',
      icon: 'file-text2',
      name: 'loginfo'
    }, {
      text: '系统设置',
      icon: 'cog',
      name: 'abnormalsetting',
      children: [{ text: '异常提醒', name: 'abnormalsetting' }, { text: '异常历史', name: 'abnormalmsg' }]
    }, {
      text: '使用手册',
      icon: 'book',
      isexturl: true,
      url: 'https://www.yuque.com/dashoo/labsop_mcs/pprryo',
      target: '_blank',
      name: 'doc'
    }]
  },

  count: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* storage */].get('dashoo_demo_count') || 0
};

if (state.session && state.session.token) {
  __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* axios */].defaults.headers.Authorization = 'Bearer ' + state.session.token;
}

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nprogress__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__axios__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__storage__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__nprogress__["a"]; });








/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);





var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: '/api/',

  timeout: 60000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress_nprogress_css__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress_nprogress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress_nprogress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nprogress__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_nprogress___default.a);

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_store__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_store___default.a);

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_libraries_i18n__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_libraries_store__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_libraries_router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_libraries_plugins__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_styles_main_scss__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_assets_styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_assets_styles_main_scss__);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$GlobalDataURL = '/dataURL/';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$GlobalRemoteUrl = '/remoteURL/';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$GlobalIoTUrl = '/IoTURL/';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$GlobalConfig = {
  security: {
    enableScreenLock: false,
    enablePasswordExpiry: false,
    enableComplexPassword: false,
    screenLockTimeout: 30 * 60 * 1000,
    passwordExpiryDays: 30 }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_libraries_plugins__["a" /* default */]);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5_libraries_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_libraries_router__["a" /* default */], { moduleName: 'route' });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.debug = "production" === 'development';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.silent = !__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.debug;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a, {
  i18n: function i18n(key) {
    return __WEBPACK_IMPORTED_MODULE_4_libraries_i18n__["a" /* default */].vm._t(key);
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  name: 'root',
  i18n: __WEBPACK_IMPORTED_MODULE_4_libraries_i18n__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5_libraries_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_6_libraries_router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

app.$mount('#app');

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libraries_utils_crypto_js__ = __webpack_require__(119);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    var _this = this;

    var validateConfirmPassword = function validateConfirmPassword(rule, value, callback) {
      if (value !== _this.passwordForm.newpass) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    var validatePassword = function validatePassword(rule, value, callback) {
      if (_this.$GlobalConfig.security.enableComplexPassword) {
        if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(value)) {
          callback(new Error('密码必须至少8位且包含数字、大小写字母及特殊字符'));
        } else {
          callback();
        }
      } else {
        if (!value) {
          callback(new Error('请输入新密码'));
        } else {
          callback();
        }
      }
    };

    return {
      isLocked: false,
      timer: null,
      timeout: this.$GlobalConfig.security.screenLockTimeout,
      lastActivity: localStorage.getItem('lastActivity') || new Date().getTime(),
      loginForm: {
        username: '',
        password: ''
      },

      showPasswordUpdate: false,
      passwordForm: {
        pass: '',
        newpass: '',
        checknewPass: ''
      },
      passwordRules: {
        pass: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newpass: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { validator: validatePassword, trigger: 'blur' }],
        checknewPass: [{ required: true, message: '请确认新密码', trigger: 'blur' }, { validator: validateConfirmPassword, trigger: 'blur' }]
      },
      currentUsername: '' };
  },
  created: function created() {
    if (this.$GlobalConfig.security.enableScreenLock) {
      this.isLocked = localStorage.getItem('isLocked') === 'true';
      this.addActivityListeners();
      this.startTimer();
    }

    if (this.$GlobalConfig.security.enablePasswordExpiry && !this.isLocked && this.$store.state.session.token) {
      this.checkPasswordExpiration();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeActivityListeners();
    this.clearTimer();
  },

  methods: {
    addActivityListeners: function addActivityListeners() {
      var _this2 = this;

      ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(function (event) {
        document.addEventListener(event, _this2.resetTimer);
      });
    },
    removeActivityListeners: function removeActivityListeners() {
      var _this3 = this;

      ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(function (event) {
        document.removeEventListener(event, _this3.resetTimer);
      });
    },
    startTimer: function startTimer() {
      var _this4 = this;

      this.timer = setInterval(function () {
        if (_this4.$route.name === 'login' || !_this4.$store.state.session.token) {
          _this4.isLocked = false;
          localStorage.setItem('isLocked', 'false');
          return;
        }

        var now = new Date().getTime();
        var lastActivity = parseInt(localStorage.getItem('lastActivity') || now);

        if (now - lastActivity >= _this4.timeout) {
          _this4.lock();
        }
      }, 1000);
    },
    clearTimer: function clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    resetTimer: function resetTimer() {
      var now = new Date().getTime();
      this.lastActivity = now;
      localStorage.setItem('lastActivity', now);
    },
    lock: function lock() {
      if (!this.$GlobalConfig.security.enableScreenLock) {
        return;
      }

      if (this.$route.name === 'login' || this.isLocked || !this.$store.state.session.token) {
        return;
      }

      this.isLocked = true;
      localStorage.setItem('isLocked', 'true');
      this.loginForm.username = '';
      this.loginForm.password = '';
    },
    unlock: function unlock() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loginData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                loginData = {
                  username: __WEBPACK_IMPORTED_MODULE_2__libraries_utils_crypto_js__["a" /* default */].encrypt(_this5.loginForm.username),
                  password: __WEBPACK_IMPORTED_MODULE_2__libraries_utils_crypto_js__["a" /* default */].encrypt(_this5.loginForm.password)
                };
                _context.next = 4;
                return _this5.$store.dispatch('createToken', loginData);

              case 4:
                _context.next = 6;
                return _this5.$store.dispatch('getCurrentUser');

              case 6:
                _context.next = 8;
                return _this5.checkPasswordExpiration();

              case 8:
                _this5.isLocked = false;
                localStorage.setItem('isLocked', 'false');
                _this5.resetTimer();
                _this5.$message.success('解锁成功');
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                _this5.$message.error('解锁失败，请重试');

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5, [[0, 14]]);
      }))();
    },
    checkPasswordExpiration: function checkPasswordExpiration() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var userInfo, lastPasswordUpdate, now, expiryTime;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (_this6.$GlobalConfig.security.enablePasswordExpiry) {
                  _context2.next = 4;
                  break;
                }

                _this6.showPasswordUpdate = false;
                return _context2.abrupt('return');

              case 4:
                if (!(!_this6.$store.state.session.token || _this6.$route.name === 'login' || _this6.isLocked)) {
                  _context2.next = 7;
                  break;
                }

                _this6.showPasswordUpdate = false;
                return _context2.abrupt('return');

              case 7:
                _context2.next = 9;
                return _this6.$store.dispatch('getCurrentUser');

              case 9:
                userInfo = _context2.sent;

                if (userInfo.Profile.Changepassworddate) {
                  _context2.next = 12;
                  break;
                }

                return _context2.abrupt('return');

              case 12:
                _this6.currentUsername = userInfo.Profile.Realname || '未知用户';

                lastPasswordUpdate = new Date(userInfo.Profile.Changepassworddate);
                now = new Date();
                expiryTime = _this6.$GlobalConfig.security.passwordExpiryDays * 24 * 60 * 60 * 1000;


                _this6.showPasswordUpdate = now - lastPasswordUpdate > expiryTime;
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](0);

                console.error('检查密码过期失败:', _context2.t0);
                _this6.showPasswordUpdate = false;

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 19]]);
      }))();
    },
    updatePassword: function updatePassword() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var encryptedPasswordData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this7.$refs.passwordForm.validate();

              case 3:
                encryptedPasswordData = {
                  pass: __WEBPACK_IMPORTED_MODULE_2__libraries_utils_crypto_js__["a" /* default */].encrypt(_this7.passwordForm.pass),
                  newpass: __WEBPACK_IMPORTED_MODULE_2__libraries_utils_crypto_js__["a" /* default */].encrypt(_this7.passwordForm.newpass),
                  checknewPass: __WEBPACK_IMPORTED_MODULE_2__libraries_utils_crypto_js__["a" /* default */].encrypt(_this7.passwordForm.checknewPass)
                };
                _context3.next = 6;
                return _this7.$services.user.put('userchangepwd', encryptedPasswordData).then(function (res) {
                  if (res.data.code === 0) {
                    _this7.showPasswordUpdate = false;
                    _this7.passwordForm = {
                      pass: '',
                      newpass: '',
                      checknewPass: ''
                    };
                    _this7.$message.success('密码更新成功');
                  } else {
                    _this7.$message.error('密码更新失败，请重试');
                  }
                });

              case 6:
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                _this7.$message.error('密码更新失败，请重试');

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[0, 8]]);
      }))();
    }
  },
  watch: {
    '$route': {
      handler: function handler(newRoute, oldRoute) {
        if (newRoute.name === 'login') {
          this.showPasswordUpdate = false;
          this.isLocked = false;
          localStorage.setItem('isLocked', 'false');
        }

        if (oldRoute) {
          switch (oldRoute.name) {
            case 'dashboard':
              Window.indexinterval && clearInterval(Window.indexinterval);
              break;
            case 'equipment':
              Window.equimentinterval && clearInterval(Window.equimentinterval);
              break;
            case 'alerts':
              Window.alerterinterval && clearInterval(Window.alerterinterval);
              break;
            case 'management':
              Window.managementinterval && clearInterval(Window.managementinterval);
              break;
          }
        }
      },

      immediate: true,
      deep: true
    },

    '$store.state.session.token': {
      handler: function handler(newToken) {
        var _this8 = this;

        if (newToken && this.$route.name !== 'login') {
          setTimeout(function () {
            _this8.checkPasswordExpiration();
          }, 1000);
        } else {
          this.showPasswordUpdate = false;
        }
      },

      immediate: true
    }
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "width": "100%",
      "height": "100%",
      "overflow": "hidden"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    staticClass: "wrapper"
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "系统已锁定",
      "visible": _vm.isLocked,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isLocked = $event
      }
    }
  }, [_c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.loginForm.username),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "username", $$v)
      },
      expression: "loginForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.unlock
    }
  }, [_vm._v("解锁")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "密码已过期",
      "visible": _vm.showPasswordUpdate,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showPasswordUpdate = $event
      }
    }
  }, [_c('div', {
    staticClass: "current-user-info"
  }, [_vm._v("\n      当前用户：" + _vm._s(_vm.currentUsername) + "\n    ")]), _vm._v(" "), _c('el-form', {
    ref: "passwordForm",
    attrs: {
      "model": _vm.passwordForm,
      "rules": _vm.passwordRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "pass",
      "label": "原密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.passwordForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "pass", $$v)
      },
      expression: "passwordForm.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newpass",
      "label": "新密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.passwordForm.newpass),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "newpass", $$v)
      },
      expression: "passwordForm.newpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checknewPass",
      "label": "确认密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.passwordForm.checknewPass),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "checknewPass", $$v)
      },
      expression: "passwordForm.checknewPass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updatePassword
    }
  }, [_vm._v("确认修改")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

module.exports = {"hello":"您好","demo":{"hello":"世界你好","hello2":"{name}你好"},"Account":"账户管理","submit":"保存","strategy":"报警策略","reset":"重置","edit":"编辑","search":"搜索","Inquire":"查询","delete":"删除","Remarks":"备注","operation":"操作","cancel":"取消","confirm":"确定","Error":"出现错误！","prompt":"提示","Handling":"处理报警历史","operating":"操作","Load":"数据拼命准备中，请稍候。。。","nodata":"无数据显示","Your":"您的设备{c}，在{t}时 温度 为{v}出现异常","logout":"注销登录","NO":"设备报警通知","warn":"此操作将永久删除该数据, 是否继续?","a":"您的设备{c}，在{t}时 温度 为{v}出现异常","b":"您的设备{c}，在{t}时 湿度 为{v}出现异常","c":"您的设备{c}，在{t}时 二氧化碳 为{v}出现异常","d":"您的设备{c}，在{t}时 氧气 为{v}出现异常","e":"您的设备{c}，在{t}时 电压 为{v}出现异常","f":"您的设备{c}，在{t}时 功率 为{v}出现异常","g":"您的设备{c}，在{t}时 发生断电情况，请及时处理","h":"您的设备{c}，在{t}时 液位 为{v}出现异常","i":"您的设备{c}，在{t}时 门禁 为{v}出现异常","userchangepwd":{"pass":"当前登录密码:","newpass":"新的登陆密码 :","checknewPass":"确认新的登录密码 :","submit":"提交","reset":"重置","please":"请输入新密码","again":"请再次输入新密码","error":"两次密码输入不一致！","tip":"请输入当前密码"},"users":{"search":"搜索","add":"新增用户","export":"导出到excel","settings":"用户权限设置","user":"编辑用户信息","Username":"账号","Realname":"用户名","Telephone":"手机","Mobile":"座机","Code":"IC卡号","role":"角色","Ordinary":"普通用户","manager":"管理用户","Remarks":"备注","organization":"所属组织","delete":"删除","operation":"操作","Permission":"权限","edit":"编辑","power":"功率","reset":"重置 ","rolechange":"请选择设备状态","cancel":"取消 ","confirm":"确定 ","Please":"请输入账号","email":"请输入正确的邮箱地址","tip":"提示","warn":"此操作将永久删除该数据, 是否继续?","dewarn":"此操作将重置用户的密码为123456, 是否继续?","Edit":"编辑用户信息","Error":"出现错误！","mess":"请选择所属组织！","select":"请选择要删除的数据"},"index":{"isnodata":"无数据显示","person":"个人设置","offline":"传感器状态（离线）","online":"传感器状态（在线）","temperature":"温度 ℃","humidity":"湿度 %","wind":"风速 m/s","pressure":"气压 hpa","power":"功率 W","electric":"电压 V","Voltage":"电压 ","Update":"更新时间 :"},"usersetting":{"name":"账号","Code":"编码","Contacts":"联系人","Unit":"单位名称","address":"单位地址","image":"上传头像","Please":"请输入单位名称","format":"上传头像图片只能是图片格式!","size":"上传头像图片大小不能超过1MB！"},"organize":{"Search":"搜索组织名称","New":"新建组织","name":"组织名称","Superior":"上级组织","Opera":"操作时间","Permission":"权限","describe":"描述","Please":"请输入组织名称","Permiss":"权限","higher":"请选择上一级组织","upper":"上一级组织不能为自身数据！","Edit":"编辑组织信息"},"management":{"Personal":"个人设置","SMS":"短信剩余","Recharge":"充值","Voice":"语音剩余","Alarm":"报警设备","No":"无报警数据","more":"查看更多","Offline":"离线","normal":"正常","Normal":"正常设备","Device":"设备名","status":"状态","data":"数据","temperature":"温度:","humidity":"湿度:","wind":"风速:","pressure":"气压:","power":"功率:","electric":"电量:","co2":"二氧化碳:","level":"液位:","doorlock":"智能锁:","offline":"离线","Abnormal":"异常设备","Alarm ":"报警信息","Last":"上次连接时间","Total":"设备总数","state":"Equipment state","Sensor":"传感器电量","number":"传感器序列号","signal":"传感器信号"},"equipment":{"electric":"电量断电","Voltage":"电压 ","New":"新增设备","Batch":"批量操作","edit":"编辑设备","Edit":"编辑设备","select":"请选择组织","Delete":"删除设备","sensor":"新增传感器","Brand":"品牌","model":"型号","Device":"设备的状态","name":"请输入设备名称","Disable":"停用","curve":"数据曲线","Map":"地图轨迹","level":"液位 mm","internet":"网络","Update":"更新时间","rolechange":"请选择设备状态","alarm":"新增报警","caveat":"报警","calibration":"校准","condition":"报警条件","strategy":"报警策略","No":"无策略","abnormality":"连续异常","first":"首次异常报警，恢复正常后提醒","Enable":"全部启用","enabled":"全部禁用","disable":"停用","Temperature":"温度","Humidity":"湿度","O2":"O2校准","CO2":"CO2校准","Choose":"请选择品牌","modelaa":"请选择型号","equipment":"设备状态","numeric":"请输入正确数字值","organization":"请选择所属组织!","device":"设备的状态","error":"出现错误！","will":"此操作将永久删除该设备的所有数据(包括监控设备以及报警设置), 是否继续?","this":"此设备的所有报警设置 ?","whether":"是否","list":"报警设置列表"},"sgmanage":{"Enter":"输入名称或序列号","serial":"网关序列号 ","title":"网关名称","OrganizeName":"所属组织","Vol":"网关电量","Signal":"网络信号","Time":"心跳时间","Add":"新增网关","add":"新增网关设备","Edit":"编辑网关设备"},"loginfo":{"Operator":"操作人","time":"操作时间","content":"内容","Alarm":"报警器","Alarma":"报警设置","Exception":"异常提醒设置","Device":"设备参数配置","Enterprise":"企业信息调整","User":"用户信息调整","Organizational":"组织结构信息调整","item":"报警项目信息调整","change":"密码修改","parameter":"报警器参数调整","status":"报警状态调整"},"actions":{"Add":"新增报警项目","name":"项目名称","type":"类型","e-mail":"邮件","URL":"网址推送","Alarm":"报 警 器","SMS":"短  信","voice":"语  音","WeChat":"微  信","Web":"网页消息","RControl":"远程控制","Send":"发送对象","sender":"请输入发送对象","email":"请输入正确的邮箱地址","uRL":"请输入正确的URL地址","phone":"请输入正确的手机号码","landline":"请输入正确的手机号码","Tip":"提示：录入多个","project":"请输入项目名称","number":"手机号码","telephone":"电话号码","item":"编辑报警项目","comma":"请使用 “,” 逗号分隔","http":"  提示：输入以 http:// 开头的URL地址 "},"abnormalsetting":{"exception":"请选择异常类型","ALL":"全部","offline":"设备离线","low":"声光设备低电","Sound":"声光设备离线","SMS":"短信余额提醒","Voice":"语音余额提醒","battery":"网关低电","Gateway":"网关离线","Time":"时间:","Select":"选择时间范围 ","device":"报警设备","equipment":"设备","selected":"删除所选","type":"异常类型","success":"成功","failure":"失败","Unsent":"未发送","View":"查看","object":"发送对象","status":"发送状态","time":"提醒时间","alarm":"报警类型 ","Alarm":"报警时间","content":"报警内容","Device":"设备","range":"请选择时间范围","history":"查看报警历史","select":"选择时间范围","below":"网关低电[网关报警请在下方选择需要报警的网关]","off":"网关离线 [网关报警请在下方选择需要报警的网关]","gateway":"请选择网关","Can":"报警类型:","can":"可在","valid":"设备离线 [请再下方选择需要报警的传感器]","Selectt":"选择网关 :","item":"报警类型 :","an":"请选择报警项目","Item":"报警项","Management":"中管理报警项目","regenerate":"重新生成","unrecoverable":"此操作不可恢复，可能会造成您的数据获取不正常，请联系客服或确认无误后执行, 是否继续?"},"reprts":{"date":"选择日期","period":"选择统计时间段","excel":"导出到excel","PDF":"导出到pdf","Set":"设置成功"},"monthreports":{"sensor":"请选择传感器","range":"选择日期范围","More":"更多操作","selected":"导出所选到excel","all":"导出全部到excel","pdf":"导出所选到pdf","allpdf":"导出全部到pdf","maximum":"导出所选最值报表","Export":"导出全部最值报表","date":"请选择日期范围","statistical":"请选择统计时间段","comparison":"请选择对比设备生成图表"},"chartreport":{"chart":"生成图表","limit":"时间范围 :","contrast":"选择对比设备","print":"打印","type":"选择对比类型","temperature":"温度","co2":"二氧化碳","so2":"二氧化硫","o2":"氧气","humidity":"湿度","Comparison":"对比类型：【温度】     单位：【℃】","a":"请选择对比设备","Unit":"对比类型：【湿度】     单位：【%】"},"organreport":{"Department":"科室名称","Equipment":"设备类型","Number":"同类型设备数量","abnormalities":"异常次数"},"alerts":{"100":"屏显内容不能多于 100 个字符","Add":"新增屏显内容","On":"屏显内容列表","number":"序列号","Numbering":"编号","type":"产品类型","Large":"大屏报警器","Bar":"条屏","Sensor":"传感器状态","not":"未连接","Electricity":"电量","Alarm":"传感器序列号","name":"名称","Binding":"绑定设备","Screen":"屏显时间","content":"屏显内容","between":"至","Already":"已播放","Not":"未播放","Please":"请输入报警器序列号","time":"请输入屏显时间","aaa":"请输入名称","number1":"请输入编号","contenta":"请输入屏显内容","sure":"确认删除本条数据吗？将同时删除报警设置和报警项目设置！！","alarm":"新增报警器","Strong":"强","general":"一般","weak":"弱","information":"新增屏显信息","screen":"屏显信息","Edit":"编辑屏显信息"},"triggerinfos":{"Device":"设备断电","device":"设备","service":"维修","Defrost":"除霜","failure":"停电","other":"其他","openw":"开关门误报","bxxd":"冰箱消毒","range":"选择时间范围","data":"导出数据","selected":"导出选中数据","page":"导出当前页数据","all":"导出所有数据","Processed":"已处理","Unprocessed":"未处理","instructions":"处理说明","time":"处理时间","processing":"报警设置列表","settings":"新增报警设置","Edit":"编辑报警设置","integer":"请输入2到30之间的整数","ddd":"请输入整数","numeric":"请输入正确数字值","trigger":"请输入触发条件值","message":"请输入消息内容","alarm":"请选择报警时间","item":"请选择报警项目","Responsible":"责任人"},"triggerdia":{"Air":"气压","clo2":"二氧化氯","c2h4":"乙烯","c2h2":"乙炔","cl2":"氯气","o3":"臭氧","electrical":"电量","level":"液位 ","Triggering":"触发条件","Alarm":"报警策略 ","Alarma":"报警状态 ","allowable":" 可在","Number":"次报警","first":"首次异常报警，恢复正常后提醒","Monday":"周一","Tuesday":" 周二","Wednesday":"周三","Thursday":"周四","Friday":"周五","Saturday":"周六","Sunday":"周天","Message":"消息内容","enter":"输入异常的数量","conditons":"请选择报警条件","LockMESS":"消息内容中{c}表示设备，{t}表示当前时间，{p}表示操作人","MESS":" 消息内容中{c}表示设备，{v}表示当前值，{t}表示当前时间"},"equdia":{"Custom":"自定义排序","Add":"新增设备","Sensor":"传感器名称","refrigeration":"冷藏","freezing":"冷冻","on":"上","in":"下","under":"中","Please":"请输入传感器序列号1","name":"请输入设备名称!","sensor":"传感器名称"},"channeldia":{"Over":"超温点上限","Deep":"深低温","Low":"超温点下限","Normal":"常温","Please":"请输入传感器序列号","upper":"请正确填写超温点上下限","enter":"上限请输入正确数字值","correct":"请填写正确的上限","numerical":"下限请输入正确数字值","Edit":"编辑传感器","Device":"设备批量设置","Not":"不操作","Enable":"启用","Disable":"停用","Alarm":"报警设置清空","copy":"报警复制","Select":"选择模板设备","target":"选择目标设备","Are":"确定执行排序操作吗, 是否继续?","device":"请选择需要设置的设备！","alarm":"请选择设备状态或者报警状态！","aaa":"确定执行设备批量设置操作吗, 是否继续","bbb":"请选择需要清空设置的设备！","ccc":"确定执行报警设置清空操作吗, 是否继续?","first":"请先选择复制模板！","ddd":"请选择目标设备！","eee":"确定执行报警复制操作吗, 是否继续?","supply":"电量"},"login":{"Login":"登录","username":"用户名","user":"请输入用户名","password":"请输入密码","Password":"密码","login":"登录","loging":"登陆中...","name":"请输入用户名","error":"发生错误了","exception":"出现异常，请稍后再试或者联系管理员！","try":"出现异常，请稍后再试！","wrong":"用户名或密码错误!","later":"服务器内部异常，请稍后再试！"},"devicechart":{"Time":"时间范围","choose":"选择时间范围","Latest":"最新数据","oxygen":"氧气","Carbon":"二氧化碳","Wind":"风速","Air":"气压","Chlorine":"二氧化氯","ethylene":"乙烯","acetylene":"乙炔","chlorine":"氯气","ozone":"臭氧"}}

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(177);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var $router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
});

$router.onError(function (error) {
  var pattern = /Loading chunk (\d)+ failed/g;
  var isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    location.reload();
  }
});
/* harmony default export */ __webpack_exports__["a"] = ($router);

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules__ = __webpack_require__(205);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var strict = "production" !== 'production';

var plugins = [];

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({ state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */], getters: __WEBPACK_IMPORTED_MODULE_3__getters__, mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__, actions: __WEBPACK_IMPORTED_MODULE_5__actions__, modules: __WEBPACK_IMPORTED_MODULE_6__modules__, strict: strict, plugins: plugins });

if (false) {
  module.hot.accept(['./getters', './mutations', './actions', './modules/options', './modules/users', './modules/demo', './modules/devices'], function () {
    store.hotUpdate({
      getters: require('./getters'),
      mutations: require('./mutations'),
      actions: require('./actions'),
      modules: {
        options: require('./modules/options'),
        users: require('./modules/users'),
        demo: require('./modules/demo'),
        devices: require('./modules/devices')
      }
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__comments__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__posts__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__terms__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tokens__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__users__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__channels__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__alerts__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__triggerinfos__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__triggers__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reports__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__monthreports__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dataexports__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__loginfos__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__authcodemans__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__abnormals__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__organizes__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__permissions__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__orgpermission__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__device__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__equipment__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__expirechannels__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__comments__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__options__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__posts__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__terms__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__tokens__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__users__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__channels__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__alerts__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__triggerinfos__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__triggers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__reports__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__monthreports__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__dataexports__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__loginfos__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__authcodemans__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__abnormals__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__organizes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__permissions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__orgpermission__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_20__device__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_21__equipment__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_22__expirechannels__["a"]; });




























/***/ })

},[213]);


// WEBPACK FOOTER //
// static/js/app.57b5b0edcfbc94919088.js